const locale = {
  placeholder: 'Izberite Äas',
};

export default locale;
